import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayDeleteLocNames =
	| 'SPSettingsScoreReportDelayDeleteTitle'
	| 'SPSettingsScoreReportDelayDeleteMessage'
	| 'SPSettingsScoreReportDelayDeleteConfirm'
	| 'SPSettingsScoreReportDelayDeleteCancel';

export const spSettingsScoreReportDelayDeleteLocs: LocDefs<SPSettingsScoreReportDelayDeleteLocNames> =
	{
		SPSettingsScoreReportDelayDeleteTitle: {
			defaultValue: 'Delete Delay Setting',
			description: 'Title for the score report delete setting dialog.',
			displayPath: `${pathStart}Delete Dialog|Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPSettingsScoreReportDelayDeleteMessage: {
			defaultValue: 'Please confirm you would like to delete the selected delay setting(s).',
			description: 'Message for the score report delete setting dialog.',
			displayPath: `${pathStart}Delete Dialog|Message`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelayDeleteConfirm: {
			defaultValue: 'Delete Delay Setting(s)',
			description: 'Confirm button for the score report delete setting dialog.',
			displayPath: `${pathStart}Delete Dialog|Confirm`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSettingsScoreReportDelayDeleteCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button for the score report delete setting dialog.',
			displayPath: `${pathStart}Delete Dialog|Cancel`,
			displayType: 'Button',
			...sharedProperties,
		},
	};

export type SPSettingsScoreReportDelayDeleteLocType =
	LocMap<SPSettingsScoreReportDelayDeleteLocNames>;
